import {COUNTRY_LIST} from "@/libs/userAbility/userAbilityRoles/rolesCountry";

const CountryList = () =>import(/* webpackChunkName 'CountryList' */ '@/components/Country/CountryList/CountryList.vue');
const CountryDetail = () =>import(/* webpackChunkName 'CountryDetail' */ '@/components/Country/CountryDetail/CountryDetail.vue');
const CountryCreate = () =>import(/* webpackChunkName 'CountryCreate' */ '@/components/Country/CountryCreate/CountryCreate.vue');

export default {
    path: 'countries',
    name: 'countries',
    redirect: 'countries/',
    meta: {
        label: 'Countries'
    },
    component: {
        name: 'Countries',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: '/',
            name: 'countries_list',
            meta: {
                accessLevel: COUNTRY_LIST,
                label: 'List'
            },
            props: true,
            component: CountryList
        },
        {
            path: 'country-detail/:id',
            name: 'country_detail',
            meta: {
                label: 'Country Detail'
            },
            props: true,
            component: CountryDetail
        },
        {
            path: 'country-create',
            name: 'country_create',
            meta: {
                label: 'Country Create'
            },
            props: true,
            component: CountryCreate
        }
    ]
};